const { BASE_URL } = require("./client");

const GET_ALL_DETAILS = BASE_URL + "/virtualCampus/";
const DELETE_VIRTUALCAMPUS = BASE_URL + "/virtualCampus/";
const DOWNLOAD_EXCEL_SHEET = BASE_URL + "/virtualCampus/download";

export { GET_ALL_DETAILS, DELETE_VIRTUALCAMPUS, DOWNLOAD_EXCEL_SHEET };
